import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import FormattedPrice from '../../misc/FormattedPrice';

function CartTotal(props) {
  return (
    <div className="cart-total-outer-container">
      <div className="cart-total-inner-container">
        {props.deliveryCharges && (
          <div className="cart-total-item-container cart-total-info">
            <FormattedMessageWrappedInSpan id="cartTotal.delivery" defaultMessage="Shipping" />
            {props.deliveryCharges.amount === 0 ? (
              <FormattedMessageWrappedInSpan id="cartTotal.deliveryFree" defaultMessage="Free" />
            ) : (
              <FormattedPrice price={props.deliveryCharges} />
            )}
          </div>
        )}
        <div className="cart-total-item-container cart-total-price">
          <FormattedMessageWrappedInSpan id="cartTotal.total" defaultMessage="Total" />
          <span>
            <FormattedPrice price={props.totalPrice} />
            {props.hasReverseCharge && <span>*</span>}
          </span>
        </div>
      </div>
      {props.hasReverseCharge && (
        <p className="cart-total-reverse-charge">
          <FormattedMessageWrappedInSpan
            id="cartTotal.reverseCharge"
            defaultMessage="* Reverse charge"
          />
        </p>
      )}
    </div>
  );
}

CartTotal.defaultProps = {
  hasReverseCharge: false,
};

CartTotal.propTypes = {
  deliveryCharges: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
  }),
  hasReverseCharge: PropTypes.bool,
  totalPrice: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
  }),
};

export default CartTotal;
